import ExtendedPath from "csi/core/ExtendedPath";
import { CustomViewAttributesOptions } from "csi/middleware/customView/attributes/CustomViewAttributesStore";
import { PreferenceView } from "csi/prefs/PreferenceView";
import Widget from "csi/table/Widget";
import declare from "dojo/_base/declare";

const EC_TYPE = "ItemType";
const EC_PURPOSE_ENGINEERING_CHANGE = "ECPurpose:EngineeringChange";

const OMIT_TYPES = new Set([
	// Affected Items
	"CareSymbol",
	"Composition",
	"CompositionPlacement",
	"Food",
	"FoodAllergen",
	"FoodClaim",
	"FoodIngredient",
	"FoodNutrient",
	"FormulatedMaterial",
	"LanguageMapLibItem",

	// Impacted Items
	"AllergenItem",
	"Artwork",
	"CareAndComposition",
	"CollectionColor",
	"CollectionMaterial",
	"CollectionMatrix",
	"ColorDataSheet",
	"DataSheetSizeLabel",
	"FoodBOM",
	"FoodBOMLineItem",
	"FoodLabelDataSheet",
	"FoodLabelItem",
	"ImageDataSheet",
	"IngredientItem",
	"MaterialBOM",
	"MaterialDataSheet",
	"MaterialSchedule",
	"MaterialScheduleColor",
	"NutrientItem",
	"PriceList",
	"PrintDesign",
	"PropertiesDataSheet",
	"RecipeDataSheet",
	"RecipeLineItem",
	"ReviewCollection",
	"ReviewColorway",
	"ReviewFood",
	"ReviewFoodSKU",
	"ReviewSKU",
	"ReviewStyle",
	"Routing",
	"SizeChart",
	"SizeChartReview",
	"SizeLabelDataSheet",
	"SpecificationDataSheet",
	"SubRouting",
	"TDSRevisionImpacted",
	"TestRun",
]);

const AffectedItemsTable = declare(Widget, {
	/**
	 * @override
	 * Default Affected Items Table View to Group by ItemType
	 */
	onCreateDefaultCustomView(cv: PreferenceView) {
		this.inherited(arguments);
		this.setDefaultGroupAndExpand(EC_TYPE);
	},

	/**
	 * @override
	 * Do not resolve any derived classes
	 */
	onCustomViewAttributeOptions(options: CustomViewAttributesOptions): void {
		const context = this.getContext();
		const node = context.getContextNode();

		this.inherited(arguments);

		if (node?.Purpose === EC_PURPOSE_ENGINEERING_CHANGE) {
			options.omitContainerCallback = (extendedPath: ExtendedPath): boolean => {
				const { endClass, endType } = extendedPath;
				const type = endClass.getMasterClass()?.type || endType;
				return OMIT_TYPES.has(type);
			};
		}
	},

	/**
	 * @override
	 * Refresh table and switchboard whenever tab switch occurs
	 */
	onTabSwitch(): void {
		this.refreshOnTabSwitch = true;
		this.inherited(arguments);
	},

});

export = AffectedItemsTable;
